export default __webpack_public_path__ + "static/media/wallet-connect.ab92ddc9.svg";